import { useCallback, useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

const useConfirmExit = (confirmExit, when = true) => {
    const { navigator } = useContext(NavigationContext);

    useEffect(() => {
        if (!when) return;

        const originalPush = navigator.push;

        navigator.push = (...args) => {
            const result = confirmExit();
            if (result !== false) originalPush(...args);
        };

        return () => {
            navigator.push = originalPush;
        };
    }, [navigator, confirmExit, when]);
};

const Prompt = ({ when, message }) => {
    const confirmExit = useCallback(() => window.confirm(message), [message]);

    useEffect(() => {
        window.onbeforeunload = when ? () => message : null;

        return () => {
            window.onbeforeunload = null;
        };
    }, [message, when]);

    useConfirmExit(confirmExit, when);
    return null;
};

export default Prompt;